import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { v4 as uuid } from 'uuid';
import { ProfileTransferTypes, ActionProfileTransferSubmit, ActionProfileTransferSuccess, ActionProfileTransferFailure, ActionDestinationAccountSuccess, ActionDestinationAccountFailure } from './types';
import { ErrorResponse, APIError, EmailTagName } from '../../helpers/types';
import { ProfileTransferService } from './effects';
import { ProfileTransferPayload, TransferStatus, TransferEmail } from '../../models/profile';

// check given account is exist or not
export const dispatchDestinationAccountSuccess = (): ActionDestinationAccountSuccess => {
  return {
    type: ProfileTransferTypes.TRANSFER_ACCOUNT_EXIST_SUBMIT_SUCCESS,
  };
};

export const dispatchDestinationAccountFailure = (): ActionDestinationAccountFailure => {
  return {
    type: ProfileTransferTypes.TRANSFER_ACCOUNT_EXIST_SUBMIT_FAILURE,
  };
};

export const dispatchTransferProfileSubmit = (): ActionProfileTransferSubmit => {
  return {
    type: ProfileTransferTypes.TRANSFER_PROFILE_SUBMIT,
  };
};
export const dispatchTransferProfileSuccess = (payload: TransferStatus): ActionProfileTransferSuccess => {
  return {
    type: ProfileTransferTypes.TRANSFER_PROFILE_SUBMIT_SUCCESS,
    payload,
  };
};

export const dispatchTransferError = (e: APIError): ActionProfileTransferFailure => {
  return {
    type: ProfileTransferTypes.TRANSFER_PROFILE_SUBMIT_FAILURE,
    error: e,
  };
};

export const actionTransferProfile = (payload: ProfileTransferPayload, partner: string) => {
  return (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    dispatch(dispatchTransferProfileSubmit());
    return ProfileTransferService.getCustomerId(payload.email).then((customerResult) => {
      return ProfileTransferService.profileTransfer({ ...payload, destination: { owner: customerResult.identity.customer.id, username: payload.email } }).then((transferResult) => {
        return ProfileTransferService.updateEmail( { profileId: payload.profileId, owner: customerResult.identity.customer.id, email: { name: `${EmailTagName.b2bcustomer}-${uuid()}`, primary: true, detail: { email: payload.transferredEmail.email}} }).then((profileResult) => {
          return ProfileTransferService.sendReportLinkToCustomerUser(payload.transferredEmail, partner).then((result) => {
            return dispatch(dispatchTransferProfileSuccess({ status: true }));
          });
        });
      });
    }).catch((e: ErrorResponse) => {
      return dispatch(dispatchTransferError(e.response));
    });
  };
};

export const actionDestinationAccountExist = (payload: TransferEmail) => {
  return (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    return ProfileTransferService.getCustomerId(payload.email).then((customerResult) => {
      return dispatch(dispatchDestinationAccountSuccess());
    }).catch((e: ErrorResponse) => {
      return dispatch(dispatchDestinationAccountFailure());
    });
  };
};